import React from 'react';

import UnknownError from '../components/UnknownError';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return <UnknownError />;
        }

        return this.props.children;
    }
}
